import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * AI Module Service Stores
 *
 * Declares the ServiceStores backing the AI views (LLM providers, task routes,
 * usage summary). ViewStores read `rootStore.<name>Store.entities` and call
 * `.find/.create/.patch/.remove` instead of the removed `createRestApi`.
 */
export const aiStores: ServiceStoreConfig[] = [
  { name: "llm-providers", options: { idField: "id", enableStorage: false } },
  // Task routes have no surrogate `id` — each row is keyed by its human-readable
  // `taskKey` (the route is PATCHed at `llm-task-routes/<taskKey>`), so that is
  // the entity-cache key the LlmRouting view edits/saves against.
  { name: "llm-task-routes", options: { idField: "taskKey", enableStorage: false } },
  // Derived read-only rollup (grouped by providerType+taskKey, no stable id) —
  // the LlmUsage view reads the find() response rows, not entity-keyed cache.
  { name: "llm-usage-summary", options: { idField: "id", enableStorage: false } },
];
